import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "components.NotFoundPage.title",
    defaultMessage: "404 Page Not Found"
  }
});
